import React from 'react';
import { Drawer } from 'antd';

export interface WorkspaceRegistryDrawerProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Оболочка Drawer для реестров Workspace.
 * Содержимое — существующие WorkspaceMyRoutes / WorkspaceMyApplications (variant="drawer").
 */
export const WorkspaceRegistryDrawer: React.FC<WorkspaceRegistryDrawerProps> = ({
  title,
  open,
  onClose,
  children,
}) => {
  const drawerWidth =
    typeof window !== 'undefined' ? Math.min(920, window.innerWidth - 24) : 920;

  return (
    <Drawer
      title={title}
      placement="right"
      width={drawerWidth}
      open={open}
      onClose={onClose}
      destroyOnClose={false}
      styles={{
        body: {
          padding: 12,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        },
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </div>
    </Drawer>
  );
};

export default WorkspaceRegistryDrawer;
